<template>
  <h1 class="headline">
    <small class="caption mr-2">{{car.maker}}</small>
    <span>{{car.name}}</span>
  </h1>
</template>

<script>
export default {
  name: 'CCarName',
  props: {
    car: {
      type: Object,
      required: true
    }
  }
}
</script>
